<template>
  <MainLayout>
    <v-container class="mt-10">
      <v-row>
        <v-breadcrumbs :items="breadcrumbs">
          <template v-slot:prepend>
            <v-icon icon="$vuetify" size="small"></v-icon>
          </template>
        </v-breadcrumbs>
        <v-divider></v-divider>
      </v-row>
      <!-- v-row>
          <v-col>
             <v-btn to="/phone/create" color="primary float-right"
              >Telefon Ekle</v-btn >
          </v-col>
        </!-->

      <v-row>
        <v-col>
          <v-row>
            <v-col
              cols="4"
              v-for="phone in phoneList.slice(0, 12)"
              :key="phone.id"
            >
              <v-card class="mb-4">
                <v-img
                  :src="phone.image"
                  height="200"
                  class="white--text align-end"
                  gradient="to bottom, rgba(0,0,0,1), rgba(0,0,0,0.5)"
                >
                  <v-card-title v-text="phone.name"></v-card-title>
                </v-img>
                <v-card-text>
                    <v-row>
                        <v-col col="6">
                            <p class="mb-0">
                                <strong>Marka/Model:</strong> {{ phone.brand }}/{{ phone.model }}
                              </p>
                              <p class="mb-0">
                                <strong>Versiyon:</strong> {{ phone.version }}
                              </p>
                              <p class="mb-0">
                                  <strong>Fiyat:</strong> {{ formatCurrency(phone.price) }} TL
                              
                                </p>
                        </v-col>
                        <v-col col="6">
                            <v-btn
                            color="green"  
                            @click="makeOffer(phone)"  
                            class="ml-2 h-100"  
                            style="flex: 1; max-width: 150px;"  
                          >
                            Teklif Ver
                          </v-btn>
                        </v-col>
                    </v-row>
                    
                  </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </MainLayout>
</template>

<script>
import { mapState } from "vuex";

//import mainService from "@/services/mainService";
import MainLayout from "@/layouts/MainLayout.vue";
 import Swal from "sweetalert2"; // SweetAlert2'yi içe aktar

export default {
  name: "PhoneSales",
  components: {
    MainLayout,
  },
  created() {
    this.fetchPhoneList();
  },
  data() {
    return {
      breadcrumbs: [
        {
          title: "Anasayfa",
          disabled: false,
          href: "pDashboard",
        },
        {
          title: "Satlık Telefonlar",
          disabled: false,
          href: "",
        },
      ],

      select: { name: "Seçiniz", id: "0" },
      phoneList: [],
      loading: false, // Yükleniyor durumu
      search: "", // Arama metni
      addPhoneDialog: false, // Telefon ekleme modal durumu

      valid: false, // Form geçerliliği
      rules: {
        required: (value) => !!value || "Bu alan gereklidir.",
      },
      typeItems: [
        { text: "Telefon", value: "normal" },
        { text: "Cari", value: "supplier" },
      ],
    };
  },

  computed: {
    ...mapState(["Phone"]), // Vuex state'inden Phone'ı al
  },
  methods: {
    makeOffer(phone) {
      // Teklif verme işlemi için gerekli kodlar
      Swal.fire(`Teklif verildi: ${phone.name} için`);
      // Burada bir modal açabilir veya başka bir işlem yapabilirsiniz
    },
    fetchPhoneList() {
      // Demo veriler
      this.phoneList = [
        {
          id: 1,
          name: "iPhone 13",
          brand: "Apple",
          model: "A2633",
          version: "128GB",
          price: 15000,
          image:
            "https://www.apple.com/v/iphone-13/home/ai/images/meta/iphone-13-og.png", // Gerçek resim
        },
        {
          id: 2,
          name: "Galaxy S21",
          brand: "Samsung",
          model: "SM-G991B",
          version: "256GB",
          price: 12000,
          image:
            "https://images.samsung.com/is/image/samsung/assets/latin_en/smartphones/galaxy-s21/images/galaxy-s21-5g-hero.jpg", // Gerçek resim
        },
        {
          id: 3,
          name: "Pixel 6",
          brand: "Google",
          model: "GBH1",
          version: "128GB",
          price: 9000,
          image:
            "https://store.google.com/intl/en_us/product/images/6/hero/hero_6.png", // Gerçek resim
        },
        {
          id: 4,
          name: "OnePlus 9",
          brand: "OnePlus",
          model: "LE2113",
          version: "256GB",
          price: 11000,
          image:
            "https://www.oneplus.com/global/oneplus-9/images/oneplus-9-hero.png", // Gerçek resim
        },
        {
          id: 5,
          name: "Xiaomi Mi 11",
          brand: "Xiaomi",
          model: "M2101K9G",
          version: "128GB",
          price: 8000,
          image: "https://www.mi.com/global/mi11/images/mi11-hero.png", // Gerçek resim
        },
        // Daha fazla demo veri ekleyebilirsiniz...
      ];
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("tr-TR", {
        style: "currency",
        currency: "TRY",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },
  },
};
</script>

<style scoped>
/* İsteğe bağlı stil ayarları */
.v-data-table {
  background-color: #ffffff;
  /* Beyaz arka plan */
  border-radius: 8px;
  /* Köşeleri yuvarla */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  /* Hafif gölge */
}

.icon-size {
  width: 30px;
  height: 30px;
}
</style>
